import Vue from 'vue';
import { Module } from 'vuex/types';
import firebase from '@/plugins/firebase';

export interface State {
  all: {
    [key: string]: Drop,
  },
  recent: string[],
}

function defaultData(): Drop {
  return {
    id: '',
    files: {},
    messages: [],
    from: '',
    project: '',
    folder: '',
    credentials: null,
    credentialsId: '',
  };
}
function getCredentialsKey(id: string) {
  return id && `drop-${id}-credentials`;
}

export const module: Module<State, any> = {
  namespaced: true,
  state: {
  	all: {},
    recent: [],
  },
  mutations: {
    insertOrUpdate(state, data) {
      if (!data) {
        return;
      }
      if (state.all[data.id]) {
        Object.entries(data).forEach(([key, value]) => {
          (state.all[data.id] as any)[key] = value;
        });
      } else {
        Vue.set(state.all, data.id, Object.assign(defaultData(), data));
      }
      return state.all[data.id];
    },
    insertOrUpdateFile(state, { id, path, dropFile }: {id: string, path: string, dropFile: DropFile}) {
      if (!state.all[id]) {
        Vue.set(state.all, id, {});
      }
      if (!state.all[id].files[path]) {
        Vue.set(state.all[id].files, path, dropFile);
      } else {
        Object.entries(dropFile).forEach(([key, value]) => {
          (state.all[id].files[path] as any)[key] = value;
        });
      }
      return state.all[id].files[path];
    },
  	delete(state, id) {
  		Vue.delete(state.all, id);
  	},
    remember(state, { id, credentialsId } : {id: string, credentialsId: string}) {
      if (!state.recent.includes(id)) {
        state.all[id].credentialsId = credentialsId;
        window.localStorage.setItem(getCredentialsKey(id), credentialsId);
        state.recent.push(id);
      }
    },
    forget(state, id) {
      if (state.recent.includes(id)) {
        if (state.all[id]) {
          state.all[id].credentialsId = null;
          state.all[id].credentials = null;
        }
        state.recent.splice(state.recent.indexOf(id), 1);
        window.localStorage.removeItem(getCredentialsKey(id));
      }
    },
  },
  actions: {
    subscribe({
      commit, state, getters, dispatch,
    }, id: string) {
      console.log(`Fetch ${id}`);
      return new Promise((resolve, reject) => {
        if (!state.all[id]) {
          commit('insertOrUpdate', { id });
        }
        if (state.all[id] && state.all[id].subscribed) {
          resolve(state.all[id]);
        } else {
          firebase.firestore().collection('drops').doc(id).onSnapshot((snapshot) => {
            commit('insertOrUpdate', { ...snapshot.data(), id, subscribed: true });
            resolve(state.all[id]);
          }, error => console.error(error));
        }
      });
    },
    addFiles({
      commit, state, getters, dispatch,
    }, { id, files } : {id: string, files: DropFileMap}) {
      // Race conditions can occour without a lock
      return new Promise((resolve, reject) => {
        firebase.firestore().collection('drops').doc(id).get()
          .then((doc) => {
            const docData = doc.data();
            const mergedFileMap: DropFileMap = Object.assign((docData || {}).files || {}, files);
            firebase.firestore().collection('drops').doc(id).update({
              files: mergedFileMap,
            });
          });
      });
    },
    loadStoredDrops({ state, dispatch, commit }) {
      for (let i = 0; i < window.localStorage.length; i++) {
        const id = window.localStorage.key(i)!.match(/^drop\-(.+)\-credentials$/);
        if (id && id.length > 0) {
          if (!state.recent.includes(id[1])) {
            commit('insertOrUpdate', {
              id: id[1],
              credentialsId: window.localStorage.getItem(id[0]),
            });
            state.recent.push(id[1]);
            dispatch('subscribe', id[1]);
          }
        }
      }
    },
  },
};
export default module;
